export { default as QrCode } from './qr-code';
